export default "__VITE_ASSET__yz7CJjSo__"